import { useNavigate, useRouter } from '@tanstack/react-router'
import { ServerCrash } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

type GeneralErrorProps = React.HTMLAttributes<HTMLDivElement> & {
  minimal?: boolean
}

export function GeneralError({
  className,
  minimal = false,
}: GeneralErrorProps) {
  const navigate = useNavigate()
  const { history } = useRouter()
  return (
    <div className={cn('relative h-svh w-full overflow-hidden bg-background', className)}>
      <div className='before:absolute before:inset-0 before:bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,hsl(0_80%_60%/0.06),transparent)]' />
      <div className='relative m-auto flex h-full w-full flex-col items-center justify-center'>
        {!minimal && (
          <>
            <div className='w-12 h-12 rounded-xl bg-destructive/10 flex items-center justify-center mb-4'>
              <ServerCrash className='w-6 h-6 text-destructive/60' />
            </div>
            <span className='text-xs font-mono uppercase tracking-[0.3em] text-muted-foreground'>
              Error 500
            </span>
            <h1 className='text-[10rem] sm:text-[14rem] font-bold leading-none tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-foreground/20 to-foreground/5'>
              500
            </h1>
          </>
        )}
        <span className='text-2xl font-semibold tracking-tight mt-2'>
          Something Went Wrong
        </span>
        <p className='text-muted-foreground text-center max-w-sm leading-relaxed mt-2'>
          We apologize for the inconvenience. Please try again later.
        </p>
        {!minimal && (
          <>
            <div className='w-16 h-px bg-border my-4' />
            <div className='flex gap-4'>
              <Button variant='ghost' onClick={() => history.go(-1)}>
                Go Back
              </Button>
              <Button onClick={() => navigate({ to: '/' })}>Back to Home</Button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
